<!--PAGE-TOP-->
<app-header></app-header>
<!--/PAGE-TOP-->
<div class="i-page-content">
  <div class="container pb-5">
    <div class="row pt-3">
      <div class="col-12 text-center py-5">
        <h1 class="i-title">ACESSE OU CRIE SUA CONTA</h1>
      </div>
    </div>
    <form (ngSubmit)="onSend()" [formGroup]="fmGroup">
      <div class="form-row px-2 px-lg-5">
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">E-MAIL</mat-label>
          <input matInput type="email" class="i-text pb-2" maxlength="255" formControlName="email" />

          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('email').errors?.email && !fmGroup.get('email').errors?.required">
            POR FAVOR, INFORME UM E-MAIL VÁLIDO
          </mat-error>
          <!-- <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('email').errors?.required">
                        CAMPO OBRIGATÓRIO
                    </mat-error> -->
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 i-text" appearance="fill">
          <mat-label class="i-text">SENHA</mat-label>
          <input matInput type="password" class="i-text pb-1" maxlength="255" formControlName="pwd" />
          <!-- <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('pwd').errors?.required">
                        CAMPO OBRIGATÓRIO
                    </mat-error> -->
        </mat-form-field>
      </div>
      <!--Button-->
      <div class="my-3 text-center"><button type="submit" class="i-btn ml-2">ACESSAR</button></div>
    </form>
    <div class="container">
      <div class="row" style="line-height: 2rem">
        <hr class="col" />
        <span class="col-1 text-center">OU</span>
        <hr class="col" />
      </div>
      <div class="row justify-content-around my-2">
        <div class="btn btn-google btn-outlined mb-4 mb-md-2" (click)="onGoogleSignIn()">
          <i class="iconify" data-icon="mdi-google"></i>
          Login com Google
        </div>

        <div class="btn btn-primary mb-4 mb-md-2" (click)="onFacebookSignIn()">
          <i class="iconify" data-icon="mdi-facebook"></i>
          Login com Facebook
        </div>
      </div>
      <div class="row align-items-center justify-content-center mt-3 mt-md-5">
        <!-- <a class="btn btn-link" (click)="onForgotPassword()">LEMBRAR SENHA</a>
        / -->
        <!-- [preserveQueryParams]="true" -->
        <a class="btn btn-link" routerLink="/cadastre-se">CRIAR CONTA</a>
      </div>
    </div>
  </div>
</div>
